/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'project-actions.project-content.archive-error-title': '無法復原專案',
  'project-actions.project-content.archive-project': '封存專案',
  'project-actions.project-content.archive-restore-error-description': '專案變更無法儲存，請稍後再試一次。',
  'project-actions.project-content.copy-link': '複製連結',
  'project-actions.project-content.copy-project': '複製專案',
  'project-actions.project-content.copy-project.cancel': '取消',
  'project-actions.project-content.copy-project.close-modal': '關閉強制回應',
  'project-actions.project-content.copy-project.error': '為您的專案命名，讓大家都知道專案內容',
  'project-actions.project-content.copy-project.failed-description': '複製目標時發生錯誤，請稍後再試一次。',
  'project-actions.project-content.copy-project.failed-description-forbidden': '您無權複製此專案。',
  'project-actions.project-content.copy-project.failed-title': '我們無法複製此專案。',
  'project-actions.project-content.copy-project.followers': '追蹤者',
  'project-actions.project-content.copy-project.include': '包含',
  'project-actions.project-content.copy-project.links': '連結',
  'project-actions.project-content.copy-project.project-name': '專案名稱',
  'project-actions.project-content.copy-project.submit': '提交',
  'project-actions.project-content.copy-project.success-description': '專案已成功複製。',
  'project-actions.project-content.copy-project.success-link': '檢視已複製的專案。',
  'project-actions.project-content.copy-project.success-title': '已複製專案「{projectName}」。',
  'project-actions.project-content.copy-project.title': '複製專案',
  'project-actions.project-content.follow': '追蹤',
  'project-actions.project-content.follow-confirmation-description':
    '我們將在每週一早上向您傳送摘要，其中包含您追蹤的所有專案更新。為什麼是星期一？<a>請在此處參閱。</a>',
  'project-actions.project-content.follow-confirmation-title': '🙌🏼 您現已追蹤此專案！',
  'project-actions.project-content.follow-error-title': '無法追蹤專案',
  'project-actions.project-content.follow-unfollow-error-description': '專案變更無法儲存，請稍後再試一次。',
  'project-actions.project-content.restore-project': '復原專案',
  'project-actions.project-content.share': '分享',
  'project-actions.project-content.unfollow': '取消追蹤',
  'project-actions.project-content.unfollow-error-title': '無法取消追蹤專案',
};
